import type { FC } from 'react';
import { Link } from '@chakra-ui/react';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
import { FacebookIcon, InstagramIcon, PinterestIcon } from '../../icons';

const messages = defineMessages({
    goToFacebook: {
        id: 'footer.social.facebook',
        defaultMessage: 'Go to Facebook',
    },
    goToInstagram: {
        id: 'footer.social.instagram',
        defaultMessage: 'Go to Instagram',
    },
    goToPinterest: {
        id: 'footer.social.pinterest',
        defaultMessage: 'Go to Pinterest',
    },
    howToOptOut: {
        id: 'footer.social.how_to_opt_out',
        defaultMessage: 'How to Opt-Out',
    },
});

export const Social: FC = () => {
    const intl = useIntl();
    return (
        <div data-testid="footer-social-container">
            <div>
                <ul className="flex gap-4">
                    <li>
                        <Link
                            title={intl.formatMessage(messages.goToFacebook)}
                            href="https://www.facebook.com/SurLaTable"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <FacebookIcon />
                        </Link>
                    </li>
                    <li>
                        <Link
                            title={intl.formatMessage(messages.goToInstagram)}
                            href="https://www.instagram.com/surlatable"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <InstagramIcon />
                        </Link>
                    </li>
                    <li>
                        <Link
                            title={intl.formatMessage(messages.goToPinterest)}
                            href="https://www.pinterest.com/surlatable"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <PinterestIcon />
                        </Link>
                    </li>
                </ul>
            </div>
            <div className="mt-4">
                <Link
                    href="https://www.surlatable.com/california-consumer-privacy-act-addendum.html/#personal-info"
                    title={intl.formatMessage(messages.howToOptOut)}
                    color="slt-black.900"
                    fontFamily="Lato,sans-serif"
                    fontSize={{ base: '0.75rem', sm: '0.875rem' }}
                    fontWeight="700"
                    lineHeight="130%"
                    letterSpacing="0.00875rem"
                    textDecorationLine="underline"
                    textTransform="capitalize"
                >
                    <FormattedMessage
                        id="footer.social.privacy_act_ca"
                        defaultMessage="Do Not Sell or Share My Personal Information: CA"
                    />
                </Link>
            </div>
            <div className="mt-4">
                <Link
                    href="https://www.surlatable.com/virginia-privacy-policy-addendum.html"
                    title={intl.formatMessage(messages.howToOptOut)}
                    color="slt-black.900"
                    fontFamily="Lato,sans-serif"
                    fontSize={{ base: '0.75rem', sm: '0.875rem' }}
                    fontWeight="700"
                    lineHeight="130%"
                    letterSpacing="0.00875rem"
                    textDecorationLine="underline"
                    textTransform="capitalize"
                >
                    <FormattedMessage
                        id="footer.social.privacy_act_va"
                        defaultMessage="Do Not Sell or Share My Personal Information: VA"
                    />
                </Link>
            </div>
        </div>
    );
};
